/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/circle-question-mark
 */
import { default as DefaultIcon } from '~icons/lucide/circle-question-mark';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const CircleQuestionMarkIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
